<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header'>Walkaround Check Questions</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/walkaround-questions/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
    entity='driver-checks'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
  ></app-grid>
</div>
